// import { compareBuild } from "semver"
export default {
  install(Vue, options) {
    Vue.prototype.$SignalRjs = {
      SignalRTimes:0,
      SignalRServer:jsonObject.SignalRServer,
      ConnectionID:'',
      Connection:'',
      ManualDisconnected:false,
      //連接SignalR
      ConnectionSignalR(){
        var this_ = this
        this.Connection = new signalR.HubConnectionBuilder().withUrl(this.SignalRServer).withAutomaticReconnect().build();
        this.Connection.on("OnConnected",
            function (Result) {  
              Vue.prototype.$SignalRjs.SignalRTimes = 0
              Vue.prototype.$Vehicle.LastEventTime = ''
              this_.ConnectionID = Result;
              Vue.prototype.$Global.Noneactive = ''
              Vue.prototype.$Global.load = false
              this_.ConnectionInvoke(Vue.prototype.$Vehicle.UnitIDsArr)
              // console.log('0')
              //console.log(this_.ConnectionID)
            }
        );
        this.Connection.on("OnUnitInfoUpdate",
            function (UnitInfos,Events) {
              // console.log(UnitInfos)
              // console.log(Events)
              Vue.prototype.$SignalRjs.SignalRTimes++;
              Vue.prototype.$Vehicle.FromSignalR = true
              var UnitInfoList = UnitInfos
              //車機列表排序
              UnitInfoList = Vue.prototype.$Vehicle.UnitInfoSort(UnitInfoList)
              //車機狀態
              Vue.prototype.$Vehicle.setUnitInfoStatus(UnitInfoList)
              //Unit屬性框更新
              if(Vue.prototype.$Vehicle.ClickUnitID != undefined || Vue.prototype.$Vehicle.ClickUnitID != ''){
                for(var i=0 ; i<Vue.prototype.$Vehicle.UnitInfoList.length ; i++){
                  if(Vue.prototype.$Vehicle.ClickUnitID == Vue.prototype.$Vehicle.UnitInfoList[i].unitId){
                    Vue.prototype.$Vehicle.ClickUnitInfo = Vue.prototype.$Vehicle.UnitInfoList[i]
                    // console.log(Vue.prototype.$Vehicle.UnitInfoList[i])
                    setTimeout(() => {
                      Vue.prototype.$Global.SetUnitmarkZindex(Vue.prototype.$Vehicle.ClickUnitID)//浮到最上面
                      Vue.prototype.$Global.SetDotOn(Vue.prototype.$Vehicle.ClickUnitID)//訊號光
                    }, 500);
                    // //表示連線
                    // if(Vue.prototype.$Vehicle.ClickUnitInfo.cameraStatus == 1){
                    //   for(var i =0;i<Vue.prototype.$Vehicle.UnitVideoShow.length;i++){
                    //     if(Vue.prototype.$Vehicle.UnitVideoShow[i].show == 0.3){
                    //       //重設Camera 圖示
                    //       Vue.prototype.$Vehicle.setUnitVideoShow()
                    //       Vue.prototype.$Vehicle.setCameraConnection()
                    //       break;
                    //     }
                    //   }
                    // }
                    // //表示離線
                    // if(Vue.prototype.$Vehicle.ClickUnitInfo.cameraStatus == 0){
                    //   //重設Camera 圖示
                    //   Vue.prototype.$Vehicle.setUnitVideoShow()
                    //   Vue.prototype.$Vehicle.setCameraConnection()
                    // }
                    // console.log(Vue.prototype.$Vehicle.ClickUnitInfo )
                    break;
                  }
                }
              }
              if(Events.length >0){
                // console.log(Vue.prototype.$Vehicle.LastEventID)
                // console.log(Events[0].eventLogId)
                //先以時間排序抓取最後一筆發生的事件
                Events = Vue.prototype.$Global.sortByKey(Events,'positionDateTimeGMT').reverse()
                //Event Alert 控制
                let currenttime = new Date(new Date().toISOString())
                for(var i = 0 ; i<Events.length;i++){
                  //計算離線在差多少時間
                  var Eventtime = new Date(Events[i].positionDateTimeGMT +'.000Z' );
                  var difference = (((currenttime.getTime() - Eventtime.getTime())/1000/60).toFixed(0)) + ' Min'
                  if(((currenttime.getTime() - Eventtime.getTime())/1000/60) < 1 ){
                    difference = (((currenttime.getTime() - Eventtime.getTime())/1000).toFixed(0)) + ' Sec'
                  }
                  Events[i].differenceTime = difference
                  if((Events[i].positionDateTimeGMT > Vue.prototype.$Vehicle.LastEventTime || Vue.prototype.$Vehicle.LastEventTime == '') && !Vue.prototype.$Vehicle.FirstData){
                    //顯示紅色框重要事件
                    Vue.prototype.$Global.EventIDEventAlert(Events[i].reportId,Events[i])
                  }
                }
                if(!Vue.prototype.$Global.showImgexample && Vue.prototype.$Vehicle.LastEventID != Events[0].eventLogId){
                  Vue.prototype.$Global.EventNewShow = true
                  Vue.prototype.$Vehicle.LastEventID = Events[0].eventLogId
                  Vue.prototype.$Vehicle.LastEventTime = Events[0].positionDateTimeGMT
                }else{
                  Vue.prototype.$Vehicle.LastEventID = Events[0].eventLogId
                  Vue.prototype.$Vehicle.LastEventTime = Events[0].positionDateTimeGMT
                }
              }
              Vue.prototype.$Vehicle.setEventInfoColor(Events)
              Vue.prototype.$Vehicle.UnitEventInfoList = Events
            }
        );
        this.Connection.onclose(error => {
          if(this.ManualDisconnected){
            this.ManualDisconnected = false
          }else{
            alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].webSocket_stopped_Please_search_for_the_vehicle_again)
          }
        });
        // this.Connection.onclose(function(e){
        //   // 關閉時想做的事
        // });
      },
      //SignalR 開始連線
      ConnectionStart(){
        this.Connection.start()
      },
      //SignalR 丟資料給後端
      ConnectionInvoke(Units){
        this.Connection.invoke('send',Units)
        this.Connection.on("OnUnitInfoUpdate")
      },
      //SignalR停止
      ConnectionStop(){
        this.ManualDisconnected = true
        this.Connection.stop()
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/SignalR.js